import React from "react";

export function LeftRectangleIcon() {
    return <svg width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.8542 0.683417C13.8026 -0.227806 15.3403 -0.227806 16.2887 0.683417C17.1739 1.53389 17.2329 2.87756 16.4657 3.79379L16.2887 3.98325L5.86298 14L16.2887 24.0168C17.1739 24.8672 17.2329 26.2109 16.4657 27.1271L16.2887 27.3166C15.4035 28.1671 14.005 28.2238 13.0514 27.4867L12.8542 27.3166L0.711312 15.6499C-0.173876 14.7994 -0.232889 13.4558 0.534274 12.5395L0.711312 12.3501L12.8542 0.683417Z" fill="#3EC1CB"/>
    </svg>;
}
